<template>
  <div>
    <headers />

    <!-- <div class="breadcrumb" :key="itemKey">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ "考试中心" }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div> -->
    <div class="content">
      <div class="situationNumBox">
        <div class="situationNum">
          <div class="num_item">
            <div class="num_item_title">{{ infoData.totalNum }}题</div>
            <div class="num_item_content">总题数</div>
          </div>
          <div class="num_item">
            <div class="num_item_title">{{ infoData.rightNum }}题</div>
            <div class="num_item_content">答对题数</div>
          </div>
          <div class="num_item">
            <div class="num_item_title">
              {{ Number(infoData.totalNum) - Number(infoData.rightNum) }}题
            </div>
            <div class="num_item_content">答错题数</div>
          </div>
        </div>
        <div>
          <div class="titleBox">
            <div class="titleBoxTitle">答题情况</div>
            <div class="titleBoxContent">
              <div class="titleBoxContentItem">
                <div class="icon1" />
                未答
              </div>
              <div class="titleBoxContentItem">
                <div class="icon2" />
                答对
              </div>
              <div class="titleBoxContentItem">
                <div class="icon3" />
                答错
              </div>
            </div>
          </div>
          <!-- 答题情况列表 -->
          <div class="resultList">
            <div
              :class="[
                'resultListItem',
                item.state == 1 && 'resultListItem1',
                item.state == 2 && 'resultListItem2',
                item.state == 3 && 'resultListItem3',
              ]"
              @click="onClickResult(index)"
              v-for="(item, index) in resultList"
              :key="item.id"
            >
              {{ index + 1 }}
            </div>
          </div>
        </div>
        <div class="contentBtn flexCenter" @click="goBack">返回</div>
      </div>
    </div>

    <openCode ref="openCode" />

    <footers />
  </div>
</template>
  
  <script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import search from "@/components/search.vue";
import openCode from "@/components/openCode.vue";
import { examSituation } from "@/api/examination";
export default {
  name: "news",
  components: {
    headers,
    footers,
    search,
    openCode,
  },
  data() {
    return {
      result: {},
      times: "",
      resultList: [], //答题情况列表
      situationId: "", //查看答题情况id
      //答题结果：1-答对；2-答错；3-未答
      answerResult: {
        1: "答对",
        2: "答错",
        3: "未答",
      },
      infoData: {},
    };
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },

  created() {
    this.result = this.$route.query;
    console.log(this.$route.query, "this.$route.query");
    this.situationId = this.$route.query.id || "";
  },
  mounted() {
    this.getSituation();
  },
  methods: {
    getSituation() {
      console.log(this.situationId, "this.situationId");

      examSituation({
        id: this.situationId,
      }).then((res) => {
        if (res.code == 200) {
          this.resultList = res.data.results;
          this.infoData = res.data;
        }
      });
    },
    onClicks() {
      if (this.result.state == 2) {
        this.$refs.openCode.openShow();
      } else {
        this.$router.replace({
          name: "examinationIndex",
        });
      }
    },
    // 查看答题情况
    onClickSituation() {
      this.$router.push({
        name: "examinationSituation",
      });
    },
    // 查看当前题目情况
    onClickResult(index) {
      this.$router.push({
        name: "examinationIndex",
        query: {
          situationId: this.situationId,
          situationIndex: index + 1,
        },
      });
    },
    //返回
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
  
  <style lang="less" scoped>
.content {
  width: 1400px;
  margin: 30px auto 40px;
  box-sizing: border-box;
  //   padding: 0 10%;
  padding-left: 6px;
  padding-top: 120px;
  text-align: center;
  min-height: 684px;
  display: flex;
  justify-content: center;
  //   flex-wrap: wrap;
  //   flex-direction: column;
  //   align-items: center;

  background: #fff;

  .situationNumBox {
    width: 36%;
  }
  .situationNum {
    padding: 0 10%;
    padding-top: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 17px;
    color: #00161a;
    line-height: 24px;
    text-align: center;
    font-style: normal;
    margin-bottom: 70px;
    .num_item {
      font-size: 16px;
      color: #00161a;
      line-height: 22px;
      text-align: center;
      font-style: normal;
      margin-right: 24px;
      .num_item_title {
        color: #d14d21;
      }
      .num_item_content {
        color: #829199;
      }
    }
  }
  .titleBox {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .titleBoxTitle {
    }
    .titleBoxContent {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .titleBoxContentItem {
    display: flex;
    align-items: center;
    margin-right: 24px;
    .icon1 {
      width: 24px;
      height: 24px;
      background: #f2f2f2;
      border-radius: 50%;
      margin-right: 8px;
    }
    .icon2 {
      width: 24px;
      height: 24px;
      background: #00d8c3;
      border-radius: 50%;
      margin-right: 8px;
    }
    .icon3 {
      width: 24px;
      height: 24px;
      background: #fa746b;
      border-radius: 50%;
      margin-right: 8px;
    }
  }
}
.resultList {
  display: flex;
  align-items: center;
  margin-top: 24px;
}
.resultListItem {
  margin-bottom: 12px;
  width: 36px;
  height: 36px;
  background: #f2f2f2;
  border-radius: 50%;
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #00161a;
  cursor: pointer;
}
.resultListItem1 {
  color: #fff;
  background: #00d8c3;
}
.resultListItem2 {
  color: #fff;
  background: #fa746b;
}
.contentBtn {
  margin: 0 auto;
  margin-top: 200px;
  cursor: pointer;
  width: 380px;
  height: 55px;
  background: #00d8c3;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 18px;
  color: #ffffff;
}
</style>
  